import React, { FunctionComponent } from 'react';
import styled from 'styled-components';
import { ConsentCheckbox } from '../../styles/ConsentCheckbox';
import { AuthorizationConfig, FullAuthorization } from './FullAuthorization';

/**
 * The "check my coverage" variant of the insurance-provider screen, shown to US non-65+ users: new
 * copy, two required consents and a self-pay escape hatch. Configured per flow so the other provider
 * screens (AU, 65+ Advantage list, legacy variants) are untouched.
 */
export type CoverageCheckLayoutConfig = {
  title: string;
  question: string;
  primaryButtonTitle: string;
  authorization: AuthorizationConfig;
  assignmentOfBenefits: { label: string };
  selfPayTitle: string;
};

export type CoverageCheckConsentValues = {
  authorization: boolean;
  assignmentOfBenefits: boolean;
};

type Props = {
  config: CoverageCheckLayoutConfig;
  values: CoverageCheckConsentValues;
  onChange: (values: CoverageCheckConsentValues) => void;
};

export const CoverageCheckConsents: FunctionComponent<Props> = ({ config, values, onChange }) => (
  <Container>
    <ConsentCheckbox
      checked={values.authorization}
      onChange={(authorization) => onChange({ ...values, authorization })}
      label={config.authorization.label}
      testId="coverage-consent-authorization"
    >
      <FullAuthorization config={config.authorization} testId="coverage-authorization" />
    </ConsentCheckbox>
    <ConsentCheckbox
      checked={values.assignmentOfBenefits}
      onChange={(assignmentOfBenefits) => onChange({ ...values, assignmentOfBenefits })}
      label={config.assignmentOfBenefits.label}
      testId="coverage-consent-assignment"
    />
  </Container>
);

const Container = styled.div`
  margin: 0 auto;
  max-width: 600px;
  text-align: left;
`;
